// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zD-z","smallCardRow":"AD-z","largeCardRow":"BD-z","productSearchRow":"CD-z","curatedRow":"DD-z"};